// globals.css 의 전역 리셋(`a, button { border: 0 }`)이 border-style 을 지우므로
// border-solid 를 명시하지 않으면 테두리가 렌더링되지 않는다(faq/publications 페이지와 동일 패턴).
export const outlineButtonClassName =
  'rounded-lg border border-solid border-[#bec2cc] bg-white text-[#575c66] shadow-[0px_5px_4px_-4px_rgba(0,0,0,0.02),0px_1px_2px_0px_rgba(0,0,0,0.06)]';
